import { useEffect, useState } from "react";

export type Route =
  | { name: "home" }
  | { name: "play"; game: "el_la" | "conj" | "vocab" }
  | { name: "results"; game: "el_la" | "conj" | "vocab" }
  | { name: "study" }
  | { name: "relay" };

function parse(hash: string): Route {
  const h = hash.replace(/^#/, "").replace(/^\/+|\/+$/g, "");
  if (!h) return { name: "home" };
  const [head, tail] = h.split("/");
  if (head === "play" && (tail === "el_la" || tail === "conj" || tail === "vocab")) {
    return { name: "play", game: tail };
  }
  if (head === "results" && (tail === "el_la" || tail === "conj" || tail === "vocab")) {
    return { name: "results", game: tail };
  }
  if (head === "study") return { name: "study" };
  if (head === "relay") return { name: "relay" };
  return { name: "home" };
}

export function navigate(route: Route): void {
  const hash =
    route.name === "home"
      ? "#/"
      : route.name === "play"
        ? `#/play/${route.game}`
        : route.name === "results"
          ? `#/results/${route.game}`
          : route.name === "study"
            ? "#/study"
            : "#/relay";
  if (location.hash !== hash) location.hash = hash;
}

export function useRoute(): Route {
  const [route, setRoute] = useState<Route>(() => parse(location.hash));
  useEffect(() => {
    const onHash = () => setRoute(parse(location.hash));
    window.addEventListener("hashchange", onHash);
    return () => window.removeEventListener("hashchange", onHash);
  }, []);
  return route;
}
